import apiClient from '@u/apiClient'

export default {
  //region fetch
  async fetchListItems({ commit }) {
    await apiClient
      .get('api/listItem')
      .then(async (response) => {
        commit('setListItemsIndex', response.data.list_items)
      })
      .catch(async (reason) => {
        console.error('fetchListItems', reason)
      })
  },
  //endregion

  //region store
  storeListItem({ commit }, payload) {
    return apiClient.post('api/listItem', payload.listItem).then((response) => {
      commit('setListItemsIndex', response.data.list_items)
      return response.data
    })
  },
  //endregion

  //region update
  updateListItem({ commit }, payload) {
    return apiClient
      .put(`api/listItem/${payload.listItem.id}`, payload.listItem)
      .then((response) => {
        commit('setListItemsIndex', response.data.list_items)
        return response.data
      })
  },
  //endregion

  //region delete
  deleteListItemById({ commit }, payload) {
    return apiClient
      .delete(`api/listItem/${payload.listItem}`)
      .then((response) => {
        commit('setListItemsIndex', response.data.list_items)
        return response.data
      })
  },
  //endregion

  //region undodelete
  undoDeleteListItemById({ commit }, payload) {
    return apiClient
      .get(`api/listItem/undo-delete/${payload.id}`)
      .then(async (response) => {
        commit('setListItems', response.data.tasks)
        commit('setlistItemMetadata', response.data.metadata)
        return response.data
      })
  }
  //endregion
}
